const topbar = {
    docs: 'Docs',
    help: 'Aide',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
